/**
 * Modifies the stats of a weapon
 */
export default class WeaponModifier {
  DamageAddition:number = 0
  DamageMultiplier:number = 1;

  constructor() {

  }
}




/** WEBPACK FOOTER **
 ** ./modifiers/WeaponModifier.ts
 **/